import React, { useState, useEffect, useCallback } from 'react';
import { sendContact, resetContactState } from './../../store/contact/contact.actions';
import Input from '../../core/Input/Input';
import Button from '../../core/Button/Button';
import Error from './../../components/Error/Error';
import { useSelector, useDispatch } from 'react-redux';
import Spinner from '../../core/Spinner/Spinner';
import './Contact.scss';
import { Helmet } from "react-helmet";

export interface IContactForm {
    name: string,
    tel?: string,
    email: string,
    message: string
};

const Contact: React.FC<{}> = React.memo(() => {
    const [ contactForm, setContactForm ] = useState<IContactForm>({ name: '', email: '', message: '' });
    const { error, fetching, msgSent } = useSelector((state: any) => state.contactStore);
    const dispatch = useDispatch();
    const resetContact = useCallback(() => { dispatch(resetContactState()); }, [dispatch]);

    useEffect(() => { resetContact(); }, [resetContact]);

    const onFormChange = (event: any = {}) => {
        setContactForm({
            ...contactForm,
            [event.target.id]: event.target.value
        });
    };

    const handleSubmit = (evt: any) => {
        evt.preventDefault();
        evt.stopPropagation();
        if (contactForm.email === '' || contactForm.name === '' || contactForm.message === '') {
            return;
        } 

        dispatch(sendContact(contactForm));
    };

    const renderContact = () => {
        if (error) {
            return <Error retry={resetContact} />;
        }

        if (fetching) {
            return <Spinner>Enviando mensaje...</Spinner>;
        }

        if (msgSent) {
            return <p>Gracias por comunicarse con nosotros! Le responderemos a la brevedad.</p>
        }

        return (
            <form
                name="contactForm"
                onSubmit={handleSubmit}>
                <div className="form-group">
                    <Input 
                        id="name"
                        type="text"
                        className="form-control"
                        value={contactForm.name}
                        change={onFormChange} 
                        placeholder="Nombre" 
                        required={true} 
                    />
                </div>
                <div className="form-group">
                    <Input 
                        id="tel" 
                        type="tel" 
                        className="form-control"
                        value={contactForm.tel}
                        change={onFormChange} 
                        placeholder="Teléfono" 
                        required={false} 
                    />
                </div>
                <div className="form-group">
                    <Input 
                        id="email" 
                        type="email" 
                        className="form-control"
                        value={contactForm.email}
                        change={onFormChange} 
                        placeholder="Email" 
                        required={true} 
                    />
                </div>

                <div className="form-group MsgContainer">
                    <textarea 
                        id="message"
                        value={contactForm.message}
                        required
                        placeholder="Su consulta, o sus datos si quiere registrarse como cliente"
                        className="form-control" 
                        onChange={onFormChange}>
                    </textarea>
                </div>

                <div className="SendBtnContainer">
                    <Button type="submit">ENVIAR</Button>
                </div>
            </form>
        );
    };

    return (
        <div className="Contacto">
            <Helmet>
                <title>Linea 2000 | Contacto</title>
                <meta name="description" content="Fabrica, fracciona y distribuye productos de altísima calidad para un mercado cada vez más exigente." />
                <meta name="keywords" content="acido, ácido, destapa cañerias, canieria, cloro, detergente, jabon, distribuidor, mendoza" />
            </Helmet>
            <div className="container SectionContainer">
                <div className="row">
                    <div className="col-md-6 col-sm-12">
                        <h3>Contacto</h3>
                        <p>Complete el siguiente formulario y nos comunicaremos <br /> con usted a la brevedad.</p>
                        <div className="separator"></div>
                        <p><b>Si desea pedir uno de nuestros productos, por favor envíanos tu CUIT, localidad y domicilio para poder comunicarnos con usted.</b></p>
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <div className="ContactoContent">
                            {renderContact()}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <h1>Depósito y administración</h1>
                        <p>Godoy Cruz 662 esq. Jorge Newbery (5515) Maipu, Mendoza.</p>
                        <iframe title="Ubicacion" width="100%" height="300px" src="https://www.google.com/maps/embed/v1/search?q=Godoy%20Cruz%20T.%20662%2C%20Maip%C3%BA%2C%20Mendoza&key=AIzaSyAStoArn4zVAhqNHzqu1OL_6oJ9fUDi7TQ"></iframe>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default Contact;